/**
 * Возвращает куку с заданным именем
 *
 * @param {String} name - имя куки
 * @return {String}
 */
export const getCookie = (name) => {
  const matches = document.cookie.match(new RegExp(
    `(?:^|; )${ name.replace(/([.$?*|{}()[\]\\+^])/g, '\\$1') }=([^;]*)`,
  ));

  return matches ? decodeURIComponent(matches[1]) : undefined;
};

/**
 * Возвращает Boolean, есть ли данная кука или нет
 *
 * @param {String} name - имя куки
 * @return {Boolean}
 */
export const checkCookie = (name) => new RegExp(
    `(?:^|; )${ name.replace(/([.$?*|{}()[\]\\+^])/g, '\\$1') }=([^;]*)`,
).test(document.cookie);

/**
 * Устанавливает куку с заданным именем, значением и опциями.
 *
 * @param {String} name - имя куки
 * @param {String|Object} value - значение куки
 * @param {Object} [options] - опций
 * @param {Number|Date} [options.expires] - Жизнь куки. Если передано число, время будет считаться в сутках.
 * @param {String} [options.domain] - На какой домен будет записан
 * @param {String} [options.path] - Путь куки
 */
export const setCookie = (name, value, options) => {
  options = options || {};

  let { expires } = options;
  let date;
  let updatedCookie;

  if (typeof expires === 'number' && expires) {
    date = new Date();
    date.setTime(date.getTime() + expires * 24 * 60 * 60 * 1000);
    // eslint-disable-next-line no-multi-assign
    expires = options.expires = date;
  }

  if (expires && expires.toUTCString) {
    options.expires = expires.toUTCString();
  }

  if (!options.domain) {
    const { hostname } = window.location;

    options.domain = hostname.substring(hostname.lastIndexOf('.', hostname.lastIndexOf('.') - 1) + 1);
  }

  if (!options.path) {
    options.path = '/';
  }

  value = encodeURIComponent(value);

  updatedCookie = `${name }=${ value}`;

  // eslint-disable-next-line guard-for-in,no-restricted-syntax
  for (const propName in options) {
    updatedCookie += `; ${ propName}`;
    const propValue = options[propName];

    if (propValue !== true) {
      updatedCookie += `=${ propValue}`;
    }
  }

  document.cookie = updatedCookie;
};
